import { render, staticRenderFns } from "./CtrlWorkflowPage.vue?vue&type=template&id=5f6b5180"
import script from "./CtrlWorkflowPage.vue?vue&type=script&lang=js"
export * from "./CtrlWorkflowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports